module.exports = __webpack_public_path__ + "img/te-mision5.0e2d0bf1.jpg";